module.exports = __webpack_public_path__ + "img/logo.5e867160.png";